import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import cloneDeep from 'lodash.clonedeep';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
import { updateSelectedReportWizardStep } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selected-report/selected-report.actions';
import { setTransitionAnalyses } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/transition_analyses/transition-analyses.actions';
import { decrementCurrentWizardStep, incrementCurrentWizardStep, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/wizard-step/wizard-step.actions';
import { CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/reducer';
import { getCurrentWizardStep, getCurrentWizardStepIndex, getTransitionAnalyses, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selectors';
import { CustomPDFReportModalEventName } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/custom-pdf-report-modal-event-name.enum';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { ModelPortfoliosService } from 'ModelPortfolioApp/ts/shared/services/model-portfolios.service';
import { SelectTransitionAnalysisBaseDirective } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/select-transition-analysis-modal/select-transition-analysis-base.directive';
import * as i0 from "@angular/core";
import * as i1 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i2 from "ModelPortfolioApp/ts/shared/services/model-portfolios.service";
import * as i3 from "@ngrx/store";
import * as i4 from "@angular/common";
import * as i5 from "@angular/forms";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i8 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i9 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
const _c0 = () => ({ visibility: "hidden" });
const _forTrack0 = ($index, $item) => $item.id;
function SelectTransitionAnalysisModalComponent_Conditional_10_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 23);
    i0.ɵɵlistener("click", function SelectTransitionAnalysisModalComponent_Conditional_10_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.nameFilterInput.setValue("")); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-close");
} }
function SelectTransitionAnalysisModalComponent_Conditional_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-search");
} }
function SelectTransitionAnalysisModalComponent_Conditional_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18)(1, "label", 25);
    i0.ɵɵelement(2, "input", 26)(3, "span", 27);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(1, _c0));
} }
function SelectTransitionAnalysisModalComponent_For_27_Conditional_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 34);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const analysis_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate3("", analysis_r4.transition_strategy, ": ", analysis_r4.initialPortfolio, " to ", analysis_r4.targetPortfolio);
} }
function SelectTransitionAnalysisModalComponent_For_27_Conditional_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 34);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const analysis_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate3("", analysis_r4.transition_strategy, ": ", analysis_r4.initialPortfolio, " grouped by ", analysis_r4.groupType);
} }
function SelectTransitionAnalysisModalComponent_For_27_Conditional_16_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 40);
    i0.ɵɵelement(1, "input", 26)(2, "span", 27);
    i0.ɵɵelementEnd();
} }
function SelectTransitionAnalysisModalComponent_For_27_Conditional_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18)(1, "div", 39);
    i0.ɵɵconditionalCreate(2, SelectTransitionAnalysisModalComponent_For_27_Conditional_16_Conditional_2_Template, 3, 0, "label", 40);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const analysis_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((ctx_r1.selectedTransitionAnalysis == null ? null : ctx_r1.selectedTransitionAnalysis.id) === analysis_r4.id ? 2 : -1);
} }
function SelectTransitionAnalysisModalComponent_For_27_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵlistener("click", function SelectTransitionAnalysisModalComponent_For_27_Template_div_click_0_listener() { const analysis_r4 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.selectTransitionAnalysis(analysis_r4)); });
    i0.ɵɵelementStart(1, "div", 29)(2, "div", 30)(3, "div", 31);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(4, "svg", 24);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(5, "div", 32);
    i0.ɵɵtext(6, "pdf");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "span", 33);
    i0.ɵɵconditionalCreate(8, SelectTransitionAnalysisModalComponent_For_27_Conditional_8_Template, 2, 3, "span", 34)(9, SelectTransitionAnalysisModalComponent_For_27_Conditional_9_Template, 2, 3, "span", 34);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(10, "div", 35);
    i0.ɵɵelement(11, "div", 36);
    i0.ɵɵpipe(12, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 37)(14, "div", 38);
    i0.ɵɵtext(15, "Me");
    i0.ɵɵelementEnd()();
    i0.ɵɵconditionalCreate(16, SelectTransitionAnalysisModalComponent_For_27_Conditional_16_Template, 3, 1, "div", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const analysis_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("name", "icon-file");
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(analysis_r4.targetPortfolio ? 8 : 9);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind2(12, 4, analysis_r4.createdDate, "longDate"));
    i0.ɵɵadvance(5);
    i0.ɵɵconditional(ctx_r1.showSelection ? 16 : -1);
} }
function SelectTransitionAnalysisModalComponent_Conditional_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21)(1, "span");
    i0.ɵɵtext(2, "There are no transition analyses.");
    i0.ɵɵelementEnd()();
} }
function SelectTransitionAnalysisModalComponent_Conditional_29_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-simple-modal-footer", 41);
    i0.ɵɵlistener("cancelHandler", function SelectTransitionAnalysisModalComponent_Conditional_29_Template_ycn_simple_modal_footer_cancelHandler_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.back()); })("submitHandler", function SelectTransitionAnalysisModalComponent_Conditional_29_Template_ycn_simple_modal_footer_submitHandler_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.submit()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("modalTestId", "select-transition-analysis-modal")("cancelButtonText", ctx_r1.cancelButtonText)("submitButtonText", ctx_r1.submitButtonText)("disableSubmission", ctx_r1.selectedTransitionAnalysis === undefined);
} }
/**
 * Select Transition Analysis Modal Component
 *
 * Used for selecting a Transition Analysis used for a module in the Custom PDF Reports in the wizard steps
 *
 * Output Properties:
 *  broadcastWizardStepEvent: emits when the wizard should move to the previous step or next step.
 *
 */
export class SelectTransitionAnalysisModalComponent extends SelectTransitionAnalysisBaseDirective {
    constructor(featureService, modelPortfoliosService, store) {
        super(modelPortfoliosService, featureService);
        this.store = store;
        this.broadcastWizardStepEvent = new EventEmitter();
        this.currentWizardStep = null;
        this.cancelButtonText = 'Back';
        this.submitButtonText = 'Next';
        this.showSelection = true;
        this.mapStateToComponent = (state) => {
            this.currentWizardStepIndex = getCurrentWizardStepIndex(state);
            this.currentWizardStep = getCurrentWizardStep(state);
            if (!this.modalOpen &&
                this.currentWizardStepIndex === 0 &&
                this.currentWizardStep?.eventName === CustomPDFReportModalEventName.SHOW_SELECT_TRANSITION_ANALYSIS_MODAL) {
                this.openModal();
            }
            if (this.currentWizardStep?.eventName === CustomPDFReportModalEventName.SHOW_SELECT_TRANSITION_ANALYSIS_MODAL) {
                if (this.currentWizardStep.modules === undefined) {
                    this.modules = [];
                }
                else {
                    this.modules = this.currentWizardStep.modules;
                }
            }
            this.transitionAnalysesModuleMap = getTransitionAnalyses(state);
        };
        this.moduleMapHasModuleData = (module) => {
            return this.transitionAnalysesModuleMap[module.step_uuid] !== undefined;
        };
        this.storeSubscription = this.store
            .select(CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY)
            .subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.storeSubscription.unsubscribe();
    }
    openModal() {
        if (Object.keys(this.transitionAnalysesModuleMap).length === 0) {
            this.selectTransitionAnalysisModalStepIndex = 0;
        }
        const transitionAnalysesModuleMap = cloneDeep(this.transitionAnalysesModuleMap);
        this.store.dispatch(setTransitionAnalyses({ transitionAnalyses: transitionAnalysesModuleMap }));
        this.modalOpen = true;
        this.initializeSelectTransitionAnalysisModal();
    }
    exitModalHandler() {
        super.exitModalHandler();
        this.store.dispatch(resetAllCustomPdfReportItems());
    }
    initializeSelectTransitionAnalysisModal() {
        const module = this.modules[this.selectTransitionAnalysisModalStepIndex];
        this.selectedTransitionAnalysis = this.moduleMapHasModuleData(module)
            ? this.transitionAnalysesModuleMap[module.step_uuid]
            : undefined;
        this.nameFilterInput.setValue('', { emitEvent: false });
        this.filterTransitionAnalysisList();
    }
    selectTransitionAnalysis(selectedTransitionAnalysis) {
        this.selectedTransitionAnalysis = selectedTransitionAnalysis;
    }
    submit() {
        const module = this.modules[this.selectTransitionAnalysisModalStepIndex];
        const transitionAnalysesModuleMap = cloneDeep(this.transitionAnalysesModuleMap);
        transitionAnalysesModuleMap[module.id] = this.selectedTransitionAnalysis;
        transitionAnalysesModuleMap[module.step_uuid] = this.selectedTransitionAnalysis;
        this.store.dispatch(setTransitionAnalyses({ transitionAnalyses: transitionAnalysesModuleMap }));
        const updatedWizardStep = cloneDeep(this.currentWizardStep);
        if (updatedWizardStep?.modules !== undefined) {
            // update the step in the report data in the modal
            this.store.dispatch(updateSelectedReportWizardStep({ newStep: updatedWizardStep }));
        }
        if (this.selectTransitionAnalysisModalStepIndex + 1 < this.modules.length) {
            this.selectTransitionAnalysisModalStepIndex += 1;
            this.initializeSelectTransitionAnalysisModal();
        }
        else {
            this.closeModal();
            this.store.dispatch(incrementCurrentWizardStep());
            this.broadcastWizardStepEvent.emit();
        }
    }
    back() {
        if (this.selectTransitionAnalysisModalStepIndex > 0) {
            this.selectTransitionAnalysisModalStepIndex -= 1;
            this.initializeSelectTransitionAnalysisModal();
        }
        else {
            this.closeModal();
            if (this.currentWizardStepIndex) {
                this.store.dispatch(decrementCurrentWizardStep());
                this.broadcastWizardStepEvent.emit();
            }
        }
    }
}
SelectTransitionAnalysisModalComponent.ɵfac = function SelectTransitionAnalysisModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SelectTransitionAnalysisModalComponent)(i0.ɵɵdirectiveInject(i1.FeatureService), i0.ɵɵdirectiveInject(i2.ModelPortfoliosService), i0.ɵɵdirectiveInject(i3.Store)); };
SelectTransitionAnalysisModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectTransitionAnalysisModalComponent, selectors: [["ycn-select-transition-analysis-modal"]], outputs: { broadcastWizardStepEvent: "broadcastWizardStepEvent" }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 30, vars: 11, consts: [[3, "closeModalHandler", "modalBaseClass", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section"], [1, "mt-2", "mb-12", "d-flex", "align-items-center"], [1, "text-bold", 3, "textContent"], [1, "width-180", "ml-auto"], [1, "field-input-group", "field-search", "input-group"], ["placeholder", "Search Folder or File", "data-test-id", "name_filter_input", 1, "form-control", "field-input", 3, "formControl"], [1, "field-input-group-actions"], [1, "btn", "btn-transparent"], [1, "table", "table-airy", "table-hover", "file-table", "overflow-auto"], [1, "thead"], [1, "tr"], [1, "th", "file-td-name", 3, "click", "ngClass"], [1, "pt-1", "pb-1", "d-inline-block"], [1, "th", "col-3", 3, "click", "ngClass"], [1, "th", "col-2"], [1, "file-td-control", "td"], [1, "tbody"], [1, "tr", "cursor-pointer"], [1, "get-started-small", "flex-auto"], [3, "modalTestId", "cancelButtonText", "submitButtonText", "disableSubmission"], [1, "btn", "btn-transparent", 3, "click"], ["ycnIcon", "", 3, "name"], [1, "custom-control", "custom-checkbox", "custom-checkbox-style1", "checkbox-single", "d-flex", 3, "ngStyle"], ["type", "checkbox", "checked", "true", "name", "securities-list", 1, "custom-control-input"], [1, "custom-control-indicator"], [1, "tr", "cursor-pointer", 3, "click"], [1, "file-td-name", "td"], [1, "file-name", "pt-1", "pb-1"], [1, "file-icon", "file-pdf"], [1, "file-abbr"], [1, "file-title"], [1, "text-bold"], [1, "td", "col-3"], [1, "file-td-wrap", "pt-1", "pb-1", 3, "textContent"], [1, "td", "col-2"], [1, "file-td-wrap", "pt-1", "pb-1"], [1, "pt-1", "pb-1"], [1, "custom-control", "custom-checkbox", "custom-checkbox-style1", "checkbox-single", "d-flex"], [3, "cancelHandler", "submitHandler", "modalTestId", "cancelButtonText", "submitButtonText", "disableSubmission"]], template: function SelectTransitionAnalysisModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function SelectTransitionAnalysisModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.exitModalHandler(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function SelectTransitionAnalysisModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.exitModalHandler(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "div", 4);
        i0.ɵɵelement(5, "div", 5);
        i0.ɵɵelementStart(6, "div", 6)(7, "div", 7);
        i0.ɵɵelement(8, "input", 8);
        i0.ɵɵelementStart(9, "div", 9);
        i0.ɵɵconditionalCreate(10, SelectTransitionAnalysisModalComponent_Conditional_10_Template, 2, 1, "button", 10)(11, SelectTransitionAnalysisModalComponent_Conditional_11_Template, 2, 1, "button", 10);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(12, "div", 11)(13, "div", 12)(14, "div", 13)(15, "div", 14);
        i0.ɵɵlistener("click", function SelectTransitionAnalysisModalComponent_Template_div_click_15_listener() { return ctx.setTableSortProperties("analysis_name"); });
        i0.ɵɵelementStart(16, "span", 15);
        i0.ɵɵtext(17, "Name");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(18, "div", 16);
        i0.ɵɵlistener("click", function SelectTransitionAnalysisModalComponent_Template_div_click_18_listener() { return ctx.setTableSortProperties("date_modified"); });
        i0.ɵɵelementStart(19, "span", 15);
        i0.ɵɵtext(20, "Date Modified");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(21, "div", 17)(22, "span", 15);
        i0.ɵɵtext(23, "Owner");
        i0.ɵɵelementEnd()();
        i0.ɵɵconditionalCreate(24, SelectTransitionAnalysisModalComponent_Conditional_24_Template, 4, 2, "div", 18);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(25, "div", 19);
        i0.ɵɵrepeaterCreate(26, SelectTransitionAnalysisModalComponent_For_27_Template, 17, 7, "div", 20, _forTrack0);
        i0.ɵɵconditionalCreate(28, SelectTransitionAnalysisModalComponent_Conditional_28_Template, 3, 0, "div", 21);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵconditionalCreate(29, SelectTransitionAnalysisModalComponent_Conditional_29_Template, 1, 4, "ycn-simple-modal-footer", 22);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("modalBaseClass", "modal-fix-scroll")("open", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", ctx.title);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("textContent", ctx.nameFilterInput.value ? "Search Results" : "Transition Analyses");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("formControl", ctx.nameFilterInput);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.nameFilterInput.value ? 10 : 11);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngClass", ctx.getSortNgClass("analysis_name"));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", ctx.getSortNgClass("date_modified"));
        i0.ɵɵadvance(6);
        i0.ɵɵconditional(ctx.showSelection ? 24 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵrepeater(ctx.filteredTransitionAnalysisList);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(!(ctx.filteredTransitionAnalysisList == null ? null : ctx.filteredTransitionAnalysisList.length) ? 28 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.showSelection ? 29 : -1);
    } }, dependencies: [i4.NgClass, i4.NgStyle, i5.DefaultValueAccessor, i5.NgControlStatus, i6.IconDirective, i7.ModalBaseComponent, i8.SimpleModalFooterComponent, i9.SimpleModalHeaderComponent, i5.FormControlDirective, i4.DatePipe], encapsulation: 2 });
